import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsMultiColumnPdfLayoutSvg = lazy(
  () => import('./svg-components/digital-forms-multi-column-pdf-layout-svg')
);

const DigitalFormsMultiColumnPdfLayoutSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsMultiColumnPdfLayoutSvg {...rest} />
  </Suspense>
);

export default DigitalFormsMultiColumnPdfLayoutSvg;
